import { Component, OnInit } from '@angular/core';
import { OverlayService } from '../../../../services/overlay.service';
import { ActivatedRoute } from '@angular/router';
import { ProductService } from '../../../../services/product.service';

@Component({
    selector: 'app-price-band-modal',
    templateUrl: './price-band-modal.component.html',
    styleUrls: ['./price-band-modal.component.scss']
})
export class PriceBandModalComponent implements OnInit {
    slug = '';
    product: any;

    breaks = {};

    constructor(
        private overlayService: OverlayService,
        private route: ActivatedRoute,
        private productService: ProductService,
    ) {
    }

    ngOnInit(): void {
        this.slug = this.route.snapshot.params.slug;
        this.getProductDetails();
    }

    close() {
        this.overlayService.closeAll();
    }

    getProductDetails() {
        this.productService.getProductDetails(this.slug).subscribe((data) => {
            this.product = data.data;
            let skuId = '';
            for (let i = 0; i < this.product.productDetails.length; i++) {
                if (skuId !== this.product.productDetails[i].skuId) {
                    skuId = this.product.productDetails[i].skuId;
                    this.breaks[skuId] = this.product.productDetails[i];
                }
            }
        });
    }
}
